import { useContext } from 'react'
import { ThemeContext } from 'contexts/themeContext'

export const useThemeContext = () => {
  return useContext(ThemeContext)
}
